export default __webpack_public_path__ + "static/media/neha.0d5b3a40.jpeg";